import { Icon } from '@blueprintjs/core';
import DetailTable from 'Components/Generic/DetailPanel/DetailTable';
import OrgNameWithDrawerButton from 'Components/SiteDrawerContainer/OrgNameWithDrawerButton';
import ServiceContractDrawerButton from 'Components/SiteDrawerContainer/ServiceContractDrawerButton';
import UserNameWithDrawerButton from 'Components/SiteDrawerContainer/UserNameWithDrawerButton';
import { SITE_PAGES } from 'Config';
import { OBJECT_STATUS } from 'Data/Enum';
import styles from 'Pages/Requests/RequestDetails/RequestInformationPanel.module.css';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { Link } from 'react-router';
import { formatMoney, isUserAuthorized } from 'Util';
import { formatDate } from 'Util/dateUtil';
import { getTagValue } from 'Util/tagUtil';
import { getTransactionCategory, getTransactionType } from '../Enum';

const TransactionInformationTable = ({
  transaction = {},
  showTransactionId = false,
}) => {
  let data = [
    ...(showTransactionId
      ? [
          {
            label: 'Transaction ID',
            value: isUserAuthorized(
              SITE_PAGES.TRANSACTION_DETAIL.requiredAuth,
            ) ? (
              <Link
                to={`${SITE_PAGES.TRANSACTION_DETAIL.to}/${transaction.id}`}>
                {transaction.id}
              </Link>
            ) : (
              transaction.id
            ),
          },
        ]
      : []),
    { label: 'Category', value: getTransactionCategory(transaction.category) },

    {
      label: 'Core Facility',
      value: (
        <OrgNameWithDrawerButton
          orgId={transaction.parent_organization_id}
          wrapText
        />
      ),
    },

    {
      label: 'Transaction Type',
      value: getTransactionType(transaction.transaction_type),
    },

    {
      label: 'Service Contract Transaction',
      value: (
        <Icon
          size='20'
          icon={
            getTagValue(transaction, 'is_service_contract') === 'true'
              ? 'tick'
              : 'blank'
          }
        />
      ),
    },

    ...(transaction?.service_contracts?.length > 0
      ? [
          {
            label: 'Service Contract',
            value: (
              <div>
                {transaction.service_contracts.map((sc, ind) => (
                  <Fragment key={ind}>
                    <ServiceContractDrawerButton
                      serviceContractId={sc.id}
                      linkToDetailId={sc.id}
                      label={
                        sc?.status === OBJECT_STATUS.ACTIVE.key
                          ? sc.name
                          : `${sc.name} (Inactive)`
                      }
                    />
                  </Fragment>
                ))}
              </div>
            ),
          },
        ]
      : []),
    {
      label: 'Transaction Date',
      value: formatDate(transaction.date_purchased),
    },
    {
      label: 'Transaction Amount',
      value: `$${formatMoney(transaction.display_amount)}`,
    },
    {
      label: 'Purchaser',
      value: <UserNameWithDrawerButton userId={transaction.purchased_by} />,
    },
    { label: 'Reference Number', value: transaction.reference_number },
    { label: 'Confirmation Number', value: transaction.confirmation_number },
    {
      label: 'Description',
      value: (
        <>
          {transaction?.notes && (
            <div
              style={{
                whiteSpace: 'pre-line',
              }}>
              {transaction.notes}
            </div>
          )}
          {!transaction?.notes && (
            <span className={styles.no_notes_label}>No comment</span>
          )}
        </>
      ),
    },
    {
      label: (
        <span style={{ color: 'var(--site-warning-color)' }}>Radioactive</span>
      ),
      value: (
        <Icon
          size='20'
          icon={getTagValue(transaction, 'is_radioactive') ? 'tick' : 'blank'}
        />
      ),
    },
  ];

  return <DetailTable data={data} />;
};

TransactionInformationTable.propTypes = {
  transaction: PropTypes.object,
  showTransactionId: PropTypes.bool,
};

export default TransactionInformationTable;
